<template>
  <div class="chart_dialog" ref="dialog">
    <div class="tabList">
      <div class="tabItem"
          v-for="(item, index) in tabList"
          @click="handleChange(index)"
        :class="{ active: active === index }"
        :key="'t' + index">
        <p>{{item.label}}</p>
        <p>({{item.count}})</p>
      </div>
    </div>
    <div class="list infinite-list-wrapper" style=" overflow: auto;">
      <ul class="infinite-list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <div v-for="(item, index) in list" class="item"
            :class="{ active: item.fileId === current.fileId }" :key="index" @click="onClick(item)">
            <p class="name">{{item.fileName}}</p>
            <p class="type">
              <span>时间节点：{{tabList[+item.timeNode].label || ''}}</span>
              <span>文件类型：{{item.fileTypeName}}</span>
            </p>
        </div>
      </ul>
      <p class="tip" v-if="loading">加载中...</p>
      <template v-if="noMore">
        <p class="tip" v-if="list && list.length">没有更多了</p>
        <p class="tip" v-else>
          <img src="@/assets/img/empty.svg" alt="">
        </p>
      </template>
    </div>
    <el-dialog :title="title" :append-to-body="true" :visible.sync="showDialog" width='1200px' class="dialog" :close-on-click-modal='false' destroy-on-close @close="close">
      <div v-loading="loadingDialog">
        <iframe :src="previewUrl" ref="iframe"></iframe>
      </div>
    </el-dialog>
  </div>
 </template>

<script>
import Base64 from '@/utils/base64.min.js'
export default {
  name: 'File',
  components: {
  },
  data () {
    return {
      active: 0,
      tabList: [{
        label: '全部',
        count: 0
      }, {
        label: '进场前',
        count: 0
      }, {
        label: '养护中',
        count: 0
      }, {
        label: '验收完成',
        count: 0
      }, {
        label: '审计定案',
        count: 0
      }],
      list: [],
      noMore: false,
      loading: false,
      page: 1,
      size: 10,
      current: '',
      title: '',
      showDialog: false,
      previewUrl: '',
      loadingDialog: false
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId
    },
    disabled () {
      return this.loading || this.noMore
    }
  },
  watch: {
    projectId () {
      this.handleChange(this.active)
    }
  },
  created () {
    this.load()
    this.loadAll()
  },
  destroyed () {
  },
  methods: {
    handleChange (tabIndex) {
      this.active = tabIndex
      this.page = 1
      this.list = []
      this.current = {}
      this.load()
      this.loadAll()
    },
    load () {
      this.loading = true
      this.$axios.get(this.$apis.file.selectYhProjectFilesByPage, {
        page: this.page,
        size: this.size,
        projectId: this.projectId,
        timeNode: this.active || ''
      }).then((res) => {
        this.page++
        this.list = res && res.list.length > 0 ? this.list.concat(res.list) : this.list
        this.noMore = this.list.length >= res.total
      }).finally(() => {
        this.loading = false
      }).catch(() => {
        this.noMore = true
      })
    },
    loadAll () {
      this.$axios.get(this.$apis.file.selectYhProjectFilesCompilation, {
        projectId: this.projectId
      }).then((res) => {
        this.tabList[0].count = res.total || 0
        this.tabList[1].count = res.up1 || 0
        this.tabList[2].count = res.up2 || 0
        this.tabList[3].count = res.up3 || 0
        this.tabList[4].count = res.up4 || 0
      })
    },
    onClick (item) {
      this.current = item
      this.onDetail()
    },
    onDetail () {
      const file = this.current.fileList[0]
      if (file) {
        this.loadingDialog = true
        this.showDialog = true
        this.title = file.fileName
        this.previewUrl = location.origin + `/preview/onlinePreview?url=${encodeURIComponent(Base64.encode(file.filePrefix + file.fileUrl + '?fullfilename=' + file.fileName))}`
        this.$nextTick(() => {
          this.$refs.iframe.addEventListener('load', () => {
            this.loadingDialog = false
          })
        })
      } else {
        this.$message.warning('请选择资料！')
      }
    },
    close () {
      this.previewUrl = ''
    }
  }
}
</script>

 <style scoped lang='scss'>
 .chart_dialog{
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #000000;
  background: #F5F5F5;

  .tabList {
    display: flex;
    gap: 6px;
    width: 100%;
    background: #F5F5F5;
    overflow: auto;
    padding: 10px;
    .tabItem {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      position: relative;
      min-width: 55px;
      height: 40px;
      background: #FFFFFF;
      cursor: pointer;
      &:not(:last-child){
        &::after {
          content: '';
          position: absolute;
          top: 4px;
          right: -5px;
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-left: 5px solid #ffffff;
          border-bottom: 5px solid transparent;
        }
      }
      &.active {
        position: relative;
        background: #1B85FF;
        color: #ffffff;
        &::after {
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-left: 5px solid #1B85FF;
          border-bottom: 5px solid transparent;
        }
      }
    }
  }
 }

.list {
  width: 100%;
  padding: 12px;
  background: #FFFFFF;
  // max-height: 200px;
  height: 240px;
  overflow:auto;
  .infinite-list {
    display: flex;
    flex-wrap: wrap;
    // display: grid;
    // grid-template-columns: repeat(4, 1fr);
    align-items: center;
    margin-top: 2px;
    cursor: pointer;
    .item{
      position: relative;
      width: 100%;
      height: 61px;
      border: 1px solid #D9D9D9;
      cursor: pointer;
      margin-bottom: 10px;
      &.active{
        border: 1px solid #1B85FF;
        .type{
          background: #E0EEFF;
        }
        &::before{
          filter: grayscale(0%);
        }
      }
      &::before{
        content: url('~@/assets/img/file/icon.svg');
        color: #FFFFFF;
        position: absolute;
        left: 3px;
        top: 5px;
        filter: grayscale(100%);
      }
      .name{
        width: 100%;
        height: 30px;
        line-height: 29px;
        padding: 0 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .type{
        display: flex;
        justify-content: space-between;
        height: 29px;
        line-height: 29px;
        padding: 0 10px 0 25px;
        background: #F5F5F5;
        span{
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.tip{
  text-align: center;
}
iframe{
  width: 100%;
  height: 600px;
}
 </style>
